import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button, Spinner } from "reactstrap";

// helpers
import { getSessionCookie } from "helpers/cookies.js";

export default function Modulos({ history }) {

    const { register, handleSubmit, setValue, clearErrors, errors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    const session = getSessionCookie();

    useEffect(() => {

    }, []);

    const onSubmit = (data) => {

    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Row style={{ marginTop: "20vh" }}>
                <Col lg="3" md="12" className="text-center">
                </Col>
                {session && session.perfil == "Administrador" &&
                    <Col lg="3" md="12" className="text-center">
                        <Card style={{ cursor: "pointer" }} onClick={() => { history.push("/setup/inicio"); }}>
                            <CardBody>
                                <Container>
                                    <Row>
                                        <Col md="12" lg="12">
                                            <i class="fas fa-user-cog fa-6x"></i>
                                        </Col>
                                        <Col md="12" lg="12">
                                            <h4>Setup</h4>
                                        </Col>
                                    </Row>
                                </Container>
                            </CardBody>
                        </Card>
                    </Col>
                }
                <Col lg={session && session.perfil == "Administrador" ? "3" : "6"} md="12" className="text-center">
                    <Card style={{ cursor: "pointer" }} onClick={() => { history.push("/indicadores/dashboard"); }}>
                        <CardBody>
                            <Container>
                                <Row>
                                    <Col md="12" lg="12">
                                        <i class="fas fa-chart-line fa-6x"></i>
                                    </Col>
                                    <Col md="12" lg="12">
                                        <h4>Indicadores</h4>
                                    </Col>
                                </Row>
                            </Container>
                        </CardBody>
                    </Card>
                </Col>
                <Col lg="3" md="12" className="text-center">
                </Col>
            </Row>
            <Row className="text-center">
                <Col lg="12" md="12">
                    <Button className="btn-link text-white" type="button" onClick={() => history.push("/auth/trocarsenha")}> Clique aqui para Trocar a Senha</Button>
                </Col>
            </Row>
        </>
    );
}